<template>
        <div>
          {{inwords}}
        </div>
			
</template>

  <script>
	  export default {
		  mounted() {
			 // console.log('Payslip started..');   
		  },
		  props: ['amount'],
				 
   
		  data() {
			  
			  return {
				  amnt: this.amount,  
                  inwords:'Loading..',
			  }
		  },
		  
		  methods:{
		  

			  
			  getinwords: function()
			  {
  
						  axios.get(this.$api_url+'/getinwords/'+this.amnt , {
							  params: {
								  status: '',
							  }
					  }).then(function(response){
					  this.inwords =response.data.data;
  
  
				  }.bind(this));
			  },
			  
  
		  },
		  created: function(){
		  
		     this.getinwords();

			 	
		  }
	  }
  </script>